var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_sigle"},[_c('div',{staticClass:"tip"},[_c('img',{staticClass:"imgtip",attrs:{"src":_vm.url,"alt":"500"}}),_c('div',[_vm._v("系统维护升级中")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }